module.exports = __webpack_public_path__ + "media/app/containers/FavoritePage/EmptyFavorite.df4f9aa0.svg";